import { apiClient } from './api'
import { resolveEventId } from './eventService'

/**
 * Attendee-facing composed pages (the page builder output). The API returns
 * ordered blocks; richtext/html blocks carry pre-sanitized `html`, dynamic
 * blocks (agenda/speakers/content) carry only type + config and are rendered
 * client-side against live event data.
 */

export type BlockType =
  | 'hero'
  | 'richtext'
  | 'html'
  | 'image'
  | 'button'
  | 'divider'
  | 'agenda'
  | 'speakers'
  | 'content'
  | 'columns'
  | 'embed'
  | 'sponsors'
  | 'eventinfo'

export interface Block {
  id: string
  blockType: BlockType
  ordinal: number
  config: Record<string, unknown>
  html?: string | null
  source?: string | null
  children?: Block[]
}

export interface PageSummary {
  id: string
  slug: string
  title: string
  showInNav: boolean
  navLabel?: string | null
  ordinal: number
  isHome: boolean
  published: boolean
  targetingRuleId?: string | null
}

export interface Page extends PageSummary {
  blocks: Block[]
}

export const pagesService = {
  listPages: async (): Promise<PageSummary[]> => {
    const id = await resolveEventId()
    return apiClient
      .get<PageSummary[]>(`/events/${id}/pages`)
      .then((r) => r.data)
  },
  getPage: async (slug: string): Promise<Page> => {
    const id = await resolveEventId()
    return apiClient.get<Page>(`/events/${id}/pages/${slug}`).then((r) => r.data)
  },
}
